import dayjs from 'dayjs'

export const checkDeadline = (deadline: string) => {
  if (!deadline) return false
  return dayjs(deadline).isBefore(dayjs())
}
